import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/createbulkuser';
import createbulkuser from './components/createbulkuser';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const createbulkUser = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Create Bulk User - Upload</h3>
      </Col>
    </Row>   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

createbulkUser.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(createbulkUser);
